Drupal.behaviors.carousel = {
  attach(context) {
    // Obtener todos los botones con la clase "mostrar-btn"
    const showBtns = document.querySelectorAll('.link--show-hidden');

    // Agregar un evento de clic a cada botón
    showBtns.forEach((btn) => {
      btn.addEventListener('click', function () {
        const targetId = this.getAttribute('data-target');
        const targetDiv = document.getElementById(targetId);

        // Comprobar el estado actual del div de características
        const isVisible = targetDiv.style.display === 'block';

        // Ocultar todos los divs de características
        const featureDivs = document.getElementsByClassName('features');
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < featureDivs.length; i++) {
          // eslint-disable-next-line security/detect-object-injection
          featureDivs[i].style.display = 'none';
        }

        // Mostrar u ocultar el div de características según su estado actual
        if (!isVisible) {
          targetDiv.style.display = 'block';
        }
      });
    });
  },
};
